var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "loading-spinner-component pa-4" },
    [
      _c("FulfillingBouncingCircleSpinner", {
        attrs: {
          animationDuration: 2000,
          size: _vm.small ? 24 : 65,
          color: _vm.$vuetify.theme.primary,
        },
      }),
      _vm._v(" "),
      _vm.info
        ? _c("small", { staticClass: "info-text" }, [
            _vm._v("\n    " + _vm._s(_vm.info) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }